import NotificationCreateView from './views/NotificationCreateView.vue'
import NotificationListView from './views/NotificationListView.vue'

export default [
  {
    path: '/notificaciones',
    name: 'notificaciones',
    component: NotificationListView
  },
  {
    path: '/notificacion-nueva',
    name: 'nuevaNotificacion',
    component: NotificationCreateView
  }
]
